module.exports = __webpack_public_path__ + "img/P28.1873860a.png";